import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'

// OBTENER TODOS LOS Roles 
export const getRoles = async() => {
    const respuesta = await PrivateInterceptor(`Base/IT/Roles`, 'GET')
    return respuesta;
}

// MODIFICAR ROL
export const modificarRol = async(IdRol,data) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Roles/add`, 'POST', data)
    return respuesta;
}

// AGREGAR ROL
export const agregarRol = async(data) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Roles/add`, 'POST', data)
    return respuesta;
}